import { Box, Center, Container, Stack } from "@chakra-ui/react";
import * as React from "react";

import { Toaster } from "../components/toaster";
import AppShell from "./app-shell";
import { AuthHero } from "./auth-hero";

export interface LoginShellProps {
  children?: React.ReactNode;
}

export default function LoginShell({ children }: LoginShellProps) {
  return (
    <AppShell bg="navy">
      <AuthHero />
      <Box
        bg="bg"
        borderRadius="xl"
        flex="1"
        py={{ base: "24", md: "32" }}
        m="1"
      >
        <Container h="full" maxW="md">
          <Center w="full" h="full">
            <Stack w="md" gap="8">
              {children}
            </Stack>
          </Center>
        </Container>
      </Box>
      <Toaster />
    </AppShell>
  );
}
